import { useMasterDataReasonCodeMappings } from "@src/presentation/providers/MasterDataReasonCodeMappingsDataProvider";
import { MasterDataListFooter } from "./MasterDataListFooter";

export const MasterDataReasonCodeMappingsFooter = () => {
  const { total, page, limit, loading, setPage } =
    useMasterDataReasonCodeMappings();

  return (
    <MasterDataListFooter
      total={total}
      page={page}
      limit={limit}
      loading={loading}
      onPageChange={setPage}
      ariaLabel="Reason Code Pagination"
    />
  );
};
